import React, { useEffect, useState, useRef } from "react";
import "./App.css";
import { useNavigate } from "react-router-dom";
import Profileimg from "../assets/user.png";
import Editicon from "../assets/edit.svg";
import { useSelector, useDispatch } from "react-redux";
import { fetchData } from "../redux/apiSlice";
import { toastify } from "../redux/controller";
import { userlogin } from '../redux/controller';

export default function Editprofile() {
  const [stepinputField, setstepInputField] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phonenumber: "",
    stripeemail: "",
    livein: "",
    website: "",
    aboutme: ""
  });
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const handleUpdateprofile = async () => {
    if(stepinputField.firstname.length<1){
      toastify({ "message": "Please enter first name" });
      return
    }else if (stepinputField.lastname.length<1){
      toastify({ "message": "Please enter last name" });
      return
    }else if (stepinputField.phonenumber.length< 1){
      toastify({ "message": "Please enter phone number" });
      return
    }else if (stepinputField.stripeemail.length< 1){
      toastify({ "message": "Please enter email for receiving stripe payment" });
      return
    }else if (!validateEmail(stepinputField.stripeemail)) {
      toastify({ "message": "Please enter a valid email address" });
      return;
    } 
    var body = {
      "apiurl": "/auth/update/profile",
      "firstname": stepinputField.firstname,
      "lastname": stepinputField.lastname,
      "phonenumber": stepinputField.phonenumber,
      "livein": stepinputField.livein,
      "website": stepinputField.website,
      "aboutme": stepinputField.aboutme,
      "stripeemail": stepinputField.stripeemail,
      headers: { "x-access-token": usertoken }
    }
    handleUpdateprofilesave(body)
  };

  const handleUpdateprofilesave = async (body) => {
    var profile = await dispatch(fetchData(body))
    if (profile && profile.payload && profile.payload.status === 200) {
      dispatch(userlogin(profile.payload.data))
      toastify({ "message": profile.payload.message })
      Navigate("/profile");
    }
    else {
      toastify({ "message": profile.payload.message })
    }
  }

  const handleUpdateprofilediscart = () => {
    Navigate("/profile");
  };
  const [userdata, setuserdata] = useState({});
  const usertoken = useSelector((state) => state.userdata.usertoken)
  const userinfo = useSelector((state) => state.userdata.userdata)
  useEffect(() => {
    console.log('userinfo')
    console.log(userinfo)
    if (userinfo) {
      setuserdata(userinfo)
      var stripeEmail  = '';
      if(userinfo.stripeemail !=null && userinfo.stripeemail.length>0){
        stripeEmail = userinfo.stripeemail;
      }else if(userinfo.stripeaccountdata!=null){
        if(userinfo.stripeaccountdata.email!=null){
          stripeEmail = userinfo.stripeaccountdata.email;
        }
      }

      setstepInputField((prevState) => ({
        ...prevState,
        ['firstname']: userinfo.firstname
      }));
      setstepInputField((prevState) => ({
        ...prevState,
        ['lastname']: userinfo.lastname
      }));
      setstepInputField((prevState) => ({
        ...prevState,
        ['email']: userinfo.email
      }));
      setstepInputField((prevState) => ({
        ...prevState,
        ['phonenumber']: userinfo.phonenumber
      }));
      setstepInputField((prevState) => ({
        ...prevState,
        ['livein']: userinfo.livein
      }));
      setstepInputField((prevState) => ({
        ...prevState,
        ['stripeemail']: stripeEmail
      }));
      setstepInputField((prevState) => ({
        ...prevState,
        ['website']: userinfo.website
      }));
      setstepInputField((prevState) => ({
        ...prevState,
        ['aboutme']: userinfo.aboutme
      }));
    }
  }, [])

  const inputsHandler = (e) => {
    console.log(e.target.name);
    setstepInputField((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));
  };

  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const files = e.target.files[0];

    const formData = new FormData();
    formData.append("user-image", files)
    const response = await fetch(process.env.REACT_APP_BASEURL + '/upload/user-image-single', {
      method: "post",
      headers: {
        "x-access-token": usertoken
      },
      body: formData
    });
    if (response.status === 200 || response.status === 201) {
      const data = await response.json();
      console.log("data")
      console.log(data.data)

      var body = {
        "apiurl": "/auth/update/profile",
        "image": data.data,
        headers: { "x-access-token": usertoken }
      }
      handleUpdateprofilesave(body)
    }

  };

  return (
    <div className="editprofile-main">
      <div className="profile-details">
        <div className="profile-top">
          <h1>Profile Details</h1>
        </div>
        <div className="profile-details-main">
          <div className="profile-details-content edit-content">
            <div className="first-part">
              <p>Profile Image</p>
            </div>
            <div className="second-part edit-img">
              {userdata.image ? <img className="Profile_img" src={process.env.REACT_APP_BASEURL + "/" + userdata.image} alt="Profileimg" /> : <img className="Profile_img" src={Profileimg} alt="Profileimg" />}
              <img className="Editicon" src={Editicon} alt="Editicon" onClick={handleDivClick} />
              <input
                type="file"
                className="file-input"
                onChange={handleFileChange}
                ref={fileInputRef}
                accept="image/png, image/gif, image/jpeg"
              />
            </div>
          </div>

          <div className="profile-details-content edit-content">
            <div className="first-part">
              <p>First Name</p>
            </div>
            <div className="second-part">
              <input
                type="text"
                className="form-control"
                placeholder="Enter First Name"
                name="firstname"
                onChange={inputsHandler}
                value={stepinputField.firstname}
              />
            </div>
          </div>

          <div className="profile-details-content edit-content">
            <div className="first-part">
              <p>Last Name</p>
            </div>
            <div className="second-part">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Last Name"
                name="lastname"
                onChange={inputsHandler}
                value={stepinputField.lastname}
              />
            </div>
          </div>

          <div className="profile-details-content edit-content">
            <div className="first-part">
              <p>Email Address </p>
            </div>
            <div className="second-part">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Email Address"
                name="email"
                readOnly="true"
                onChange={inputsHandler}
                value={stepinputField.email}
              />
            </div>
          </div>

          <div className="profile-details-content edit-content">
            <div className="first-part">
              <p>Email for receiving stripe payment</p>
              <span>(booking fees, refund security fees, etc)</span>
            </div>
            <div className="second-part">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Email for receiving stripe payment"
                name="stripeemail"
                onChange={inputsHandler}
                value={stepinputField.stripeemail}
              />
            </div>
          </div>

          <div className="profile-details-content edit-content">
            <div className="first-part">
              <p>Phone Number </p>
            </div>
            <div className="second-part">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Phone Number"
                name="phonenumber"
                onChange={inputsHandler}
                value={stepinputField.phonenumber}
              />
            </div>
          </div>

          <div className="profile-details-content edit-content">
            <div className="first-part">
              <p>I Live in</p>
            </div>
            <div className="second-part">
              <input
                type="text"
                className="form-control"
                placeholder=""
                name="livein"
                onChange={inputsHandler}
                value={stepinputField.livein}
              />
            </div>
          </div>

          <div className="profile-details-content edit-content">
            <div className="first-part">
              <p>Website</p>
            </div>
            <div className="second-part">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Website"
                name="website"
                onChange={inputsHandler}
                value={stepinputField.website}
              />
            </div>
          </div>

          <div className="profile-details-content edit-content">
            <div className="first-part">
              <p>About Me</p>
            </div>
            <div className="second-part">
              <div className="form-floating">
                <textarea
                  className="form-control"
                  placeholder="Leave a comment here"
                  id="floatingTextarea2"
                  name="aboutme"
                  onChange={inputsHandler}
                  value={stepinputField.aboutme}
                ></textarea>
                <label for="floatingTextarea2">Type here...</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="editpro-container">
        <button className="Discard" onClick={handleUpdateprofilediscart}>
          Discard
        </button>
        <button className="Update" onClick={handleUpdateprofile}>
          Update Profile
        </button>
      </div>
    </div>
  );
}
